export interface ReturnCalendarData {
    EntityMasterReturnId: number;
    MasterReturnId: number;
    ReturnName: string;
    VertexCompanyCode: string;
    LocationCode: string;
    RegistrationNumber: string;
    Frequency: string;
    LocalCode: string;
    DueDay: string;
    PaymentMethod: string;
    FileMethod: string;
    NonVertexReturn: boolean;
    TaxSchema: string;
    TaxPayerVerification: string;
    TaxType: string;
    TaxCode: string;
  }